import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const KIOSKCARTRESETTIMERBLOCK_LEGACY_FIELD_ORDER = [
  "display_modal_after_user_event_delay",
  "refresh_after_modal_delay",
  "refresh_without_user_event_delay",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskCartResetTimerBlockDescriptor: _generatedKioskCartResetTimerBlockDescriptor,
  kioskCartResetTimerBlockBlocDefinition,
  kioskCartResetTimerBlockDashboardLayout,
  kioskCartResetTimerBlockConfig,
  kioskCartResetTimerBlockResolveConfig,
  kioskCartResetTimerBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk cart reset timer",
    componentType: "KioskCartResetTimerBlockComponent",
    category: "system",
    description: "Kiosk cart reset timer.",
    keywords: [],
    allowedIn: [
      { bloc: "MainLayoutComponent", slot: "global_features" },
      { bloc: "MainLayoutComponent", slot: "footer" },
      { bloc: "KioskMainLayoutComponent", slot: "global_features" },
      { bloc: "KioskMainLayoutComponent", slot: "footer" },
    ],
    sharedFields: {},
  },

  () => ({
    display_modal_after_user_event_delay: propertyValue({
      type: "text",
      value: "30",
      options: {
        label:
          "pages.blocks.kiosk-cart-reset-timer.display-modal-after-user-event-delay.label",
        help: "pages.blocks.kiosk-cart-reset-timer.display-modal-after-user-event-delay.help",
        placeholder: "30",
      },
    }),
    refresh_after_modal_delay: propertyValue({
      type: "text",
      value: "30",
      options: {
        label:
          "pages.blocks.kiosk-cart-reset-timer.refresh-after-modal-delay.label",
        help: "pages.blocks.kiosk-cart-reset-timer.refresh-after-modal-delay.help",
        placeholder: "30",
      },
    }),
    refresh_without_user_event_delay: propertyValue({
      type: "text",
      value: "300",
      options: {
        label:
          "pages.blocks.kiosk-cart-reset-timer.refresh-without-user-event-delay.label",
        help: "pages.blocks.kiosk-cart-reset-timer.refresh-without-user-event-delay.help",
        placeholder: "300",
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-cart-reset-timer.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-cart-reset-timer.fieldset.delays.label",
            fields: [
              "display_modal_after_user_event_delay",
              "refresh_after_modal_delay",
              "refresh_without_user_event_delay",
            ],
          },
        ],
      },
    ],
  }),
);

export function kioskCartResetTimerBlockDescriptor(): IBlockDescriptor;
export function kioskCartResetTimerBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskCartResetTimerBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskCartResetTimerBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedKioskCartResetTimerBlockDescriptor,
    kioskCartResetTimerBlockProperties,
    fieldOrder,
  );
}

export {
  kioskCartResetTimerBlockBlocDefinition,
  kioskCartResetTimerBlockDashboardLayout,
  kioskCartResetTimerBlockProperties,
  kioskCartResetTimerBlockConfig,
  kioskCartResetTimerBlockResolveConfig,
};

export type KioskCartResetTimerBlockConfig =
  typeof kioskCartResetTimerBlockConfig;
